import { useSelector } from 'react-redux';
import LassoSnackbar from '../../../components/LassoSnackbar';
import { selectFileSummary } from '../../data-wrangler/dataWranglerSlice';

const SummarySnackbar = () => {
    const { loading } = useSelector(selectFileSummary);
    const renderContent = () => {
        if (loading) {
            return <LassoSnackbar
                open={loading}
                variant="system"
                message="Loading File Transfer Summary Data"
                closable={false}
            />
        } else {
            return null;
        }
    }
    return (
        renderContent()
    )
}

export default SummarySnackbar;